<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.participants.name' | translate }}
      </span>
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
<td class="th-plugin-line--data" *ngFor="let message of messages">
          <span innerHtml="{{ message | translate: { value: plugin } }}"></span>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <table class="ir-plugin-table optimisation-equipment" *ngIf="participants && participants.length > 0">
      <tbody style="vertical-align: top">
        <tr class="th-plugin-line--subheader">
          <td>
            <span>{{ 'plugins.participants.participant.name' | translate }}</span>
          </td>
          <td>
            <span>{{ 'plugins.participants.participant.function' | translate }}</span>
          </td>
        </tr>
        <tr class="th-plugin-line--content" *ngFor="let participant of participants">
          <td>
            <span>{{ participant.Name }}</span>
          </td>
          <td>
            <span>{{ participant.Function }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
